import React, { useEffect, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Grid, Typography, Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import service from '../../apis/service';
import columns from './ZombieTableColumns';
import ShowProgress from '../ui/Backdrop';
import { apiEndpoints } from '../../constants/apiEndpoints';
import EditPencil from '../../assets/EditPencil';
import TrashCanIcon from '../../assets/TrashCan';
import EditZombie from './components/EditZombie';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import useFetchData from './hooks/useFetchData';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';

const ZombieTable = () => {
  const { getList, zombieList, rowCount } = useFetchData();

  const [selectedHash, setSelectedHash] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [showEditEmployee, setShowEditEmployee] = useState(false);
  const [zombie, setZombie] = useState(null);

  const [tableState, setTableState] = useState({
    sorting: [],
    globalFilter: '',
    pagination: {
      pageIndex: 0,
      pageSize: 10,
    },
  });

  useEffect(() => {
    const { pagination, sorting, globalFilter } = tableState;
    getList(pagination, sorting, globalFilter);
  }, [getList, tableState]);

  const handleEditEmployee = (emp) => {
    setZombie(emp);
    setShowEditEmployee(true);
  };

  const handleCloseEditEmp = () => {
    setZombie(null);
    setShowEditEmployee(false);
    const { pagination, sorting, globalFilter } = tableState;
    getList(pagination, sorting, globalFilter);
  };

  const handleConfirm = async () => {
    try {
      if (!selectedHash) return;
      await service.delete(apiEndpoints.DELETE_ZOMBIE.replace('ID', selectedHash));
      handleDeleteConfirmClose();
      notifySuccess('Employee deleted successfully');
      const { pagination, sorting, globalFilter } = tableState;
      getList(pagination, sorting, globalFilter);
    } catch (error) {
      handleDeleteConfirmClose();
      ErrorToast(error);
    }
  };

  const handleDeleteConfirmClose = () => {
    setSelectedHash(null);
    setOpenDeleteConfirm(false);
  };
  const handleDelete = (hash) => {
    setSelectedHash(hash);
    setOpenDeleteConfirm(true);
  };
  const handleRefresh = () =>
    setTableState((prev) => ({
      ...prev,
      pagination: { pageIndex: 0, pageSize: 10 },
    }));

  return (
    <Grid>
      <br />
      <Grid item>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h5" component="h2">
            Zombie Table
          </Typography>
          <Button onClick={handleRefresh}>
            <Refresh />
          </Button>
        </Grid>
      </Grid>
      <br />
      <Grid item>
        <MaterialReactTable
          columns={columns()}
          data={zombieList}
          manualSorting
          manualPagination
          enableColumnFilters={false}
          filterFns={{}}
          debugTable
          getRowId={(row) => row.id?.toString()}
          enableGlobalFilter
          manualFiltering
          globalFilterFn={null}
          onGlobalFilterChange={(value) => {
            setTableState((prev) => ({
              ...prev,
              globalFilter: value,
              pagination: { ...prev.pagination, pageIndex: 0 },
            }));
          }}
          onSortingChange={(sortFn) => {
            const sorting = sortFn(tableState.sorting);
            setTableState((prev) => ({
              ...prev,
              sorting,
            }));
          }}
          onPaginationChange={(pageFn) => {
            const pagination = pageFn(tableState.pagination);
            setTableState((prev) => ({
              ...prev,
              pagination,
            }));
          }}
          rowCount={rowCount}
          state={{
            sorting: tableState.sorting,
            pagination: tableState.pagination,
          }}
          muiTableBodyRowProps={{ hover: true }}
          enableStickyHeader
          enableBottomToolbar
          enableTopToolbar
          enableRowActions
          positionActionsColumn="last"
          renderRowActions={({ row: { original } }) => (
            <>
              <EditPencil
                onClick={() => handleEditEmployee(original)}
                titleAccess="Edit"
                style={{ cursor: 'pointer', marginRight: '8px' }}
              />
              <TrashCanIcon
                onClick={() => handleDelete(original?.hash)}
                titleAccess="Delete"
                style={{ cursor: 'pointer' }}
              />
            </>
          )}
        />
      </Grid>

      {showEditEmployee && <EditZombie isOpen handleClose={handleCloseEditEmp} zombie={zombie} />}

      <ConfirmationDialog
        title="Are you sure you want to delete this employee?"
        subText="Once done you cannot undo this action."
        onClose={handleDeleteConfirmClose}
        isOpen={openDeleteConfirm}
        confirmFn={handleConfirm}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="335px"
        height="229px"
      />

      <ShowProgress />
    </Grid>
  );
};

export default ZombieTable;
